import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/antd.css'
import MyRoute from "./route";
import {BrowserRouter as Router} from 'react-router-dom';
import {ConfigProvider} from "antd";
import locale from 'antd/lib/locale/zh_CN'
import {CookiesProvider} from "react-cookie";

ReactDOM.render(
    <CookiesProvider>
        <ConfigProvider locale={locale}>
            <Router>
                <MyRoute/>
            </Router>
        </ConfigProvider>
    </CookiesProvider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
